@if (variant() === 'flat') {
  <div data-divider-wrapper>
    <bspk-divider />
  </div>
}

<div data-button-wrapper>
  <ng-content select="[bspk-button][variant=secondary]">
    @if (secondaryLabel()) {
      <button bspk-button size="large" variant="secondary" [width]="layout() === 'filled' ? 'fill' : 'hug'" (click)="secondaryClick.emit($event)">{{ secondaryLabel() }}</button>
    }
  </ng-content>
  <ng-content select="[bspk-button][variant=primary]">
    <button bspk-button size="large" variant="primary" [width]="layout() === 'filled' ? 'fill' : 'hug'" (click)="primaryClick.emit($event)">{{ primaryLabel() }}</button>
  </ng-content>
</div>
